import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import BudgetTable from "../../BudgetTable";

import Slider from "./Slider";
import MediaQuery from "react-responsive";
const budget = {
  header: [
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
    "2023-2024",
  ],
  rows: {
    row1: [
      "Satellite Data",
      "0.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "3.0",
      "21.0",
    ],
    row2: [
      "Field Experimentation & OutSoursing Activities",
      "0.0",
      "5.0",
      "120.0",
      "90.0",
      "35.0",
      "35.0",
      "35.0",
      "35.0",
      "355.0",
    ],
    row3: [
      "NRSC Manpower",
      "2.8",
      "8.2",
      "8.2",
      "8.2",
      "8.2",
      "8.2",
      "8.2",
      "8.2",
      "60.1",
    ],
    row4: [
      "Project Scientists",
      "0.0",
      "18.5",
      "18.5",
      "18.5",
      "18.5",
      "18.5",
      "18.5",
      "18.5",
      "129.8",
    ],
    row5: [
      "Data Analysis",
      "1.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "2.0",
      "15.0",
    ],
    row6: [
      "Hardware & Software + Maintenance",
      "12.0",
      "33.0",
      "1.0",
      "4.1",
      "4.1",
      "4.1",
      "4.1",
      "4.1",
      "66.4",
    ],
    row7: [
      "ALT DEM / High Resolution Satellite DEM Generation",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row8: [
      "Travel & Field Works",
      "1.0",
      "1.3",
      "1.3",
      "1.3",
      "1.3",
      "1.3",
      "1.3",
      "1.3",
      "10.1",
    ],
    row9: [
      "Training & Workshops",
      "0.0",
      "5.0",
      "12.0",
      "12.0",
      "5.0",
      "2.0",
      "2.0",
      "2.0",
      "40.0",
    ],
    row10: [
      "Sub - Total 1",
      "16.8",
      "76.0",
      "166.0",
      "139.1",
      "77.1",
      "74.1",
      "74.1",
      "74.1",
      "697.4",
    ],
    row11: [
      "Project Management @ 5% of Sub - Total 1",
      "0.8",
      "3.8",
      "8.3",
      "7.0",
      "3.9",
      "3.7",
      "3.7",
      "3.7",
      "34.9",
    ],
    row12: [
      "Sub - Total 2",
      "17.7",
      "79.8",
      "174.3",
      "146.1",
      "81.0",
      "77.8",
      "77.8",
      "77.8",
      "732.3",
    ],
    row13: [
      "Organization Overheads @ 5% of Sub - Total 2",
      "0.9",
      "4.0",
      "8.7",
      "7.3",
      "4.0",
      "3.9",
      "3.9",
      "3.9",
      "36.6",
    ],
    row14: [
      "Grand Total",
      "18.5",
      "83.8",
      "183.0",
      "153.4",
      "85.0",
      "81.7",
      "81.7",
      "81.7",
      "768.9",
    ],
  },
};
export default class FLFinancialProposal extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
          height: "800px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />

          <div className="card" style={{ flexGrow: "1", overflowX: "auto" }}>
            <MediaQuery minWidth={991}>
              <div
                className="card-body"
                style={{ margin: "auto", padding: "10px" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Operational Web-based National Hydrological Modelling System
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <div className="card-body" style={{ padding: "10px" }}>
                <h3 align="center" style={{ color: "#002171" }}>
                  Operational Web-based National Hydrological Modelling System
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
